import * as TccActions from './tccActions';
import * as TccListActions from './listTccActions';
import * as TccSaleRegisterActions from './tccSales';

const Actions = {
  ...TccActions,
  ...TccListActions,
  ...TccSaleRegisterActions,
};

export default Actions;
